import type {IScrollInfo} from "~/shared/interfaces/composables";

function useScrollInfo(element: HTMLDivElement) {
  let prevScrollState = 0;
  const scrollInfo = reactive<IScrollInfo>({
    scrollTop: 0,
    isScrollDown: null,
  })


  const scrollEventListener = () => {
    let currentScroll = element.scrollTop;

    scrollInfo.scrollTop = currentScroll;

    scrollInfo.isScrollDown = currentScroll >= prevScrollState;

    prevScrollState = currentScroll;
  }

  element.addEventListener('scroll', scrollEventListener)

  return scrollInfo;
}

export default useScrollInfo
